module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/BC3041-2eb4d64df8ade48226ebcff72b36f015.png";